export default __webpack_public_path__ + "static/media/laptop.bc1ca877.svg";